export const MIN_MODAL_CONTENT_HEIGHT = "500px";
